import { fr, enUS, enGB, de } from 'date-fns/locale';

export const locale = (country) => {
  switch (country) {
    case 'US':
      return enUS;
    case 'UK':
      return enGB;
    case 'EU':
      return enUS;
    case 'FR':
      return fr;
    case 'DE':
      return de;
    default:
      return enUS;
  }
};
